import React from 'react';

const FeedbackHeader = () => {
  return (
    <h1>Feedback</h1>
  );
};

export default FeedbackHeader;
